import React from "react";
import { Row, Col } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import EPref from '../../../../assets/imgs/logos/2025/preference_branco.svg'

const MaintenancEpref: React.FC = () => {
    return(
    <div className="maintenance-container ePref">
            <Row className="justify-content-center align-items-center vh-100">
              <Col md={7} className="text-center">
                <img src={EPref} className="imgFaktory w-100"/>
                <a
                className="txtColor"
                href="https://api.whatsapp.com/send?1=pt_BR&amp;phone=5515996804923"
                >
                    <i className="fab fa-whatsapp  mr-1"></i> +55 (15) 99680-4923
                </a>
                <div className="pb-4">
                    <i className="fa fa-envelope mr-1"></i>
                    <a href="mailto:financeiro@prefsuite.com.br" className="txtColor">
                    financeiro@prefsuite.com.br
                    </a>
                </div>
                <h1 style={{color:"white"}}>Site em Manutenção</h1>
                <p>Estamos realizando atualizações para melhorar a sua experiência.</p>
                <p>Retornaremos em breve.</p>

      
                <Link to="/" className="mt-4 btn btn-light col">
                  Voltar para página inicial <BsArrowRight className="ml-2"/>
                </Link>
              </Col>
            </Row>
          </div>
          )
};
export default MaintenancEpref;
